// src/utils/ipfsConfig.ts
// Singleton for IPFS gateway URL — set once from the backend tenant record at app startup.
// The backend Tenant.apiKeys.ipfsGatewayUrl is the single source of truth.

let _ipfsGatewayUrl = '';

export const setIpfsGatewayUrl = (url: string) => {
  _ipfsGatewayUrl = url;
};

export const getIpfsGatewayUrl = (): string => {
  if (!_ipfsGatewayUrl) {
    console.warn('[IPFS] Gateway URL not yet loaded from tenant record. Ensure IpfsGatewayLoader is mounted.');
  }
  return _ipfsGatewayUrl;
};
